import { render, staticRenderFns } from "./ChamadasEdit.vue?vue&type=template&id=2039eb77&scoped=true"
import script from "./ChamadasEdit.vue?vue&type=script&lang=js"
export * from "./ChamadasEdit.vue?vue&type=script&lang=js"
import style0 from "./ChamadasEdit.vue?vue&type=style&index=0&id=2039eb77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2039eb77",
  null
  
)

export default component.exports